import { Component, HostBinding, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';
import { MessageResourceManager } from '../../../resources';
import { BaseFieldComponent } from '../core/base-field/base-field.component';
import { FieldTypes } from '@nts/std/types';
import { UUIDHelper } from '@nts/std/utility';
import type { ComponentViewModelInterface, ResponsiveConfigurationInterface } from '@nts/std/interfaces';

@Component({
  selector: 'nts-spacer-box',
  templateUrl: './spacer-box.component.html',
  styleUrls: ['./spacer-box.component.scss'],
  standalone: true,
  imports: []
})
export class SpacerBoxComponent extends BaseFieldComponent implements OnChanges, OnInit, OnDestroy {

  private readonly destroy$ = new Subject<void>();
  private spacerVisibilitySubscription: Subscription = null;
  private spacerIsVisible = true;
  private viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 0;

  @HostBinding('class.additional-field')
  @Input() override additionalField = false;

  @Input() override isHidden = false;

  @Input() spacers: Map<string, ComponentViewModelInterface> = null;

  @Input() uniqueId = UUIDHelper.generateUUID();

  @Input() responsiveConfiguration: ResponsiveConfigurationInterface = null;

  @HostBinding('class.is-hidden')
  get hostIsHidden(): boolean {
    const spacerIsVisible = this.spacerIsVisible;
    // const responsiveConfiguration = resolveResponsiveConfiguration(this.viewportWidth, this.responsiveConfiguration);
    return this.isHidden === true || !spacerIsVisible; // || responsiveConfiguration?.isVisible === false;
  }

  @HostBinding('attr.data-spacer-id')
  get hostSpacerId(): string {
    return this.uniqueId;
  }

  @HostBinding('class.full-column')
  @Input() fullColumn = false;

  override type = FieldTypes.Spacer;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['spacers'] || changes['uniqueId']) {
      this.syncSpacerVisibility();
    }
  }

  ngOnInit(): void {
    this.syncSpacerVisibility();
    this.syncViewportWidth();

    if (typeof window !== 'undefined') {
      fromEvent(window, 'resize')
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.syncViewportWidth());
    }
  }

  ngOnDestroy(): void {
    this.spacerVisibilitySubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isDisabled(): boolean {
    return false;
  }
  get path(): string {
    return '';
  }
  get name(): string {
    return '';
  }
  get description(): string {
    return MessageResourceManager.Current.getMessage('std_FieldTypes_' + FieldTypes[FieldTypes.Spacer]);
  }
  get displayName(): string {
    return MessageResourceManager.Current.getMessage('std_FieldTypes_' + FieldTypes[FieldTypes.Spacer]);
  }

  private syncViewportWidth(): void {
    this.viewportWidth = typeof window !== 'undefined' ? window.innerWidth : this.viewportWidth;
  }

  private syncSpacerVisibility(): void {
    this.spacerVisibilitySubscription?.unsubscribe();

    const spacerViewModel = this.spacers?.get(this.uniqueId);

    this.spacerIsVisible = spacerViewModel?.isVisible ?? true;

    if (spacerViewModel?.isVisible$ != null) {
      this.spacerVisibilitySubscription = spacerViewModel.isVisible$.pipe(skip(1)).subscribe((isVisible) => {
        this.spacerIsVisible = isVisible ?? true;
      });
    } else {
      this.spacerVisibilitySubscription = null;
    }
  }
}
